export default __webpack_public_path__ + "static/media/laravel.6ad3fbdd.svg";